export const notificationTranslations = {
    deleteContact: {
        title: 'Contacto eliminado',
        message: 'El contacto se eliminó correctamente.'
    },
    deleteContactFailed: {
        title: 'Error al eliminar contacto',
        message: 'No se pudo eliminar el contacto. Inténtalo de nuevo.'
    },
    createdContact: {
        title: 'Contacto creado',
        message: 'Se creó correctamente un nuevo contacto.'
    },
    updatedContact: {
        title: 'Contacto actualizado',
        message: 'El contacto se actualizó correctamente.'
    },
    updatedClient: {
        title: 'Cliente actualizado',
        message: 'El cliente se actualizó correctamente.'
    },
    errorUpdatingClient: {
        title: 'Error al actualizar cliente',
        message: 'Hubo un error al actualizar el cliente.'
    },
    primaryContactEmailAlreadyInUser: {
        title: 'El correo electrónico del contacto principal ya está en uso',
        message:
            'El correo electrónico asociado con el contacto principal seleccionado ya está en uso por otro usuario en la plataforma. Verifique nuevamente y considere usar un correo electrónico principal diferente para este contacto.'
    },
    createdClient: {
        title: 'Cliente creado',
        message: 'El cliente se creó correctamente.'
    },
    errorCreatingClient: {
        title: 'Error al crear cliente',
        message: 'Hubo un error al crear el cliente.'
    },
    createdLoan: {
        title: 'Préstamo creado',
        message: 'El préstamo se creó correctamente.'
    },
    errorCreatingLoan: {
        title: 'Error al crear préstamo',
        message: 'Hubo un error al crear el préstamo.'
    },
    updatedLoan: {
        title: 'Préstamo actualizado',
        message: 'El préstamo se actualizó correctamente.'
    },
    errorUpdatingLoan: {
        title: 'Error al actualizar préstamo',
        message: 'Hubo un error al actualizar el préstamo.'
    },
    resetProgress: {
        title: 'Nuevas dependencias',
        message:
            'Debido al cambio que se acaba de realizar, es posible que haya preguntas adicionales que deban responderse, o las respuestas que ya dio ahora pueden ser inválidas. Continúe con el formulario y revise sus respuestas.'
    },
    reassignPrimary: {
        title: 'Contacto principal reasignado',
        message: 'El contacto principal de esta organización se reasignó correctamente.'
    },
    loggedOut: {
        title: '¡El cierre de sesión fue exitoso!',
        message: 'Ha cerrado la sesión correctamente de la plataforma BEEP.'
    },
    logInEmailSent: {
        title: '¡Correo electrónico de inicio de sesión enviado!',
        message: 'Revise su correo electrónico para obtener el enlace de inicio de sesión.'
    },
    incorrectEmail: {
        title: '¡Error en la confirmación por correo electrónico!',
        message:
            'El correo electrónico que proporcionó no coincide con el que tenemos en nuestro sistema. Vuelva a abrir el enlace de inicio de sesión que le enviamos e intente nuevamente.'
    },
    invalidEmailLink: {
        title: '¡Hay un problema con este enlace!',
        message:
            'Este enlace de correo electrónico puede haber expirado o ya pudo haber sido utilizado para iniciar sesión. Ingrese su correo electrónico en el campo de inicio de sesión para solicitar un nuevo correo electrónico de inicio de sesión.'
    },
    loggedInWithGoogle: {
        title: '¡Inicio de sesión exitoso con Google!',
        message: 'Ha iniciado su sesión correctamente con Google.'
    },
    loggedInWithMicrosoft: {
        title: '¡Inicio de sesión exitoso con Microsoft!',
        message: 'Ha iniciado su sesión correctamente con Microsoft.'
    },
    userUpdateSuccessful: {
        title: '¡El usuario fue actualizado correctamente!',
        message: 'Ha actualizado correctamente los datos del usuario.'
    },
    userUpdateFailed: {
        title: '¡Error al actualizar el usuario!',
        message: 'Hubo un error al actualizar los datos del usuario. Inténtalo de nuevo más tarde.'
    },
    userCreateSuccessful: {
        title: '¡Usuario creado correctamente!',
        message: 'Ha creado correctamente un nuevo usuario.'
    },
    userCreateFailed: {
        title: '¡Error al crear usuario!',
        message: 'Hubo un error al crear un nuevo usuario. Inténtalo de nuevo más tarde.'
    },
    signinEmailUpdated: {
        title: '¡El correo electrónico fue actualizado correctamente!',
        message:
            'Ha actualizado correctamente su correo electrónico de inicio de sesión. En el futuro, utilice el nuevo correo electrónico para iniciar su sesión.'
    },
    emailUpdateFailed: {
        title: '¡Error al actualizar el correo electrónico!',
        message: 'Hubo un error al actualizar su correo electrónico. Inténtalo de nuevo más tarde.'
    },
    inviteEmailSend: {
        title: '¡Correo electrónico de invitación enviado!',
        message: 'Se envió una invitación para unirse a su organización a {{email}}.'
    },
    credentialsRevoked: {
        title: '¡Credenciales revocadas!',
        message:
            'El acceso a su organización en la plataforma BEEP ha sido revocado para el siguiente correo electrónico: {{email}}'
    },
    approveSurvey: {
        title: '¡Encuesta aceptada!',
        message: 'Las respuestas de esta encuesta han sido revisadas y aceptadas.'
    },
    rejectSurvey: {
        title: '¡Encuesta rechazada!',
        message:
            'Las respuestas de esta encuesta han sido rechazadas. La encuesta se enviará de vuelta al cliente para que realice las modificaciones necesarias.'
    },
    onboardingSubmitted: {
        title: '¡Integración completada!',
        message: 'Gracias por revisar la información que tenemos registrada.'
    },
    onboardingFailed: {
        title: '¡Error al enviar la encuesta de integración!',
        message:
            'Hubo un error al finalizar el proceso de integración. Inténtalo de nuevo y, si sigue habiendo problemas, comuníquese directamente con CIC.'
    },
    surveySubmitted: {
        title: '¡Encuesta enviada!',
        message:
            'Gracias por enviar esta encuesta. La revisaremos y nos comunicaremos con usted si tenemos más preguntas.'
    },
    surveySubmissionFailed: {
        title: '¡Error al enviar la encuesta!',
        message:
            'Hubo un error al enviar esta encuesta. Inténtalo de nuevo y, si sigue habiendo problemas, comuníquese directamente con CIC.'
    },
    enrollSuccess: {
        title: '¡El cliente se ha inscrito exitosamente!',
        message:
            'Este cliente ha sido inscrito en las encuestas BEEP. El contacto principal ahora debería recibir un correo electrónico que lo invite a incorporarse.'
    },
    enrollFailed: {
        title: '¡Error en la inscripción del cliente!',
        message:
            'Hubo un error al matricular a este cliente en las encuestas BEEP. Vuelva a intentarlo o comuníquese con Hivemetric para obtener ayuda.'
    },
    loanGroupCreateSuccessful: {
        title: '¡Grupo de préstamos creado!',
        message: 'El nuevo grupo de préstamos fue creado correctamente.'
    },
    loanGroupCreateFailure: {
        title: '¡Grupo de préstamos no creado!',
        message: 'Hubo un problema al guardar este grupo de préstamos.'
    },
    loanGroupEditSuccessful: {
        title: '¡Grupo de préstamos actualizado!',
        message: 'Los cambios en al grupo de préstamos fueron guardados correctamente.'
    },
    loanGroupEditFailure: {
        title: '¡Error al actualizar el grupo de préstamos!',
        message: 'Hubo un problema al guardar los cambios del grupo de préstamos.'
    },
    surveyBatchCreateSuccessful: {
        title: '¡{{generatedCount}} encuestas creadas!',
        message:
            'Puede filtrar Futuras encuestas en la tabla de encuestas para ver la colección de encuestas programadas .'
    },
    surveyBatchCreatedNoSurveys: {
        title: '¡No se crearon encuestas!',
        message: 'No hay grupos de préstamos elegibles para los parámetros seleccionados.'
    },
    surveyBatchCreateFailure: {
        title: '¡Error al crear la colección de encuestas!',
        message: 'Hubo un problema al crear la colección de encuestas solicitadas.'
    },
    surveyDispatchSuccessful: {
        title: '¡Encuesta enviada!',
        message: 'El contacto principal de esta organización será notificado por correo electrónico.'
    },
    surveyDispatchFailure: {
        title: '¡Error al enviar la encuesta!',
        message: 'Hubo un problema al enviar la encuesta al contacto principal.'
    },
    surveyDispatchReminderSuccessful: {
        title: '¡Recordatorio enviado!',
        message: 'El contacto principal de esta organización recibirá una notificación por correo electrónico.'
    },
    surveyDispatchReminderFailure: {
        title: '¡Error al enviar el recordatorio de la encuesta!',
        message: 'Hubo un problema al enviar el recordatorio de la encuesta al contacto principal.'
    },
    surveyDeleteSuccessful: {
        title: '¡Encuesta eliminada!',
        message: 'La encuesta fue eliminada correctamente.'
    },
    surveyCreateSuccess: {
        financial: {
            title: 'Financial survey created!',
            message: 'The financial survey was successfully generated'
        }
    },
    surveyDeleteFailure: {
        title: '¡Error al eliminar la encuesta!',
        message:
            'Hubo un problema al eliminar la encuesta. Inténtalo de nuevo más tarde o comuníquese con un miembro del equipo de CIC.'
    },
    surveyGenerationNotifications: {
        financial: {
            existing_survey: {
                title: 'Could not create survey!',
                message: 'A financial survey for the selected target year already exists'
            }
        }
    },
    onboardingReminder: {
        title: '¡Recordatorio enviado!',
        message: 'Se ha enviado un recordatorio por correo electrónico al contacto principal de esta organización'
    },
    onboardingReminderFailed: {
        title: '¡El envío del recordatorio falló!',
        message:
            'Hubo un problema al enviar el recordatorio por correo electrónico. Por favor, inténtelo de nuevo más tarde.'
    }
};
